(function($){
    $(document).ready(() => {
        $('#osf-accordion-container [data-accordion]').accordion();
    })
})(jQuery);